export enum DateType {
  CreatedDate = 'date',
  PulloutDate = 'pulloutSchedule',
  DeliveryDate = 'deliverySchedule',
  MTYPU = 'pickupSchedule',
  ReturnDate = 'returnSchedule'
}
